// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"c7b88d2a","787":"441ea27f","815":"4edf85a4"}[chunkId] + ".chunk.js";
};